import {
  ALL_APP_IDS,
  ALL_APPS,
  ALL_VIEW_IDS,
  ALL_VIEWS,
} from 'constants/appConstants';
import MainCardWrapper from 'layout/MainLayout/MainCardWrapper';
import PermissionsRouteWrapper from 'views/pages/components/PermissionsRouteWrapper';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import FullHeightMainCardWrapper from 'layout/MainLayout/FullHeightMainCardWrapper';
import ViewTabs from 'layout/MainLayout/ViewTabs';
import { ORG_PREFERENCES_TABS } from 'views/org/OrgPreferences';

const TeamsTable = Loadable(
  lazy(() => import('views/properties/Teams/TeamsTable'))
);
const Tags = Loadable(lazy(() => import('views/properties/Tags/TagsTable')));

export const PropertiesRoutes = [
  {
    path: `${ALL_APPS.PROPERTIES.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.PROPERTIES.id,
          view: ALL_VIEW_IDS.TEAMS_TABLE,
        }}
      >
        <Navigate to={ALL_VIEWS.TEAMS_TABLE.path ?? ''} replace />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_VIEWS.TEAMS_TABLE.path}`,
    element: (
      <>
        <ViewTabs appId={ALL_APP_IDS.PROPERTIES} />
        <FullHeightMainCardWrapper viewTabs>
          <PermissionsRouteWrapper
            permissionScope={{
              app: ALL_APPS.PROPERTIES.id,
              view: ALL_VIEW_IDS.TEAMS_TABLE,
            }}
          >
            <TeamsTable />
          </PermissionsRouteWrapper>
        </FullHeightMainCardWrapper>
      </>
    ),
  },
  {
    path: `${ALL_VIEWS.TEAMS_PREFERENCES.path}`,
    element: (
      <>
        <ViewTabs appId={ALL_APP_IDS.PROPERTIES} />
        <MainCardWrapper>
          <PermissionsRouteWrapper
            permissionScope={{
              app: ALL_APPS.PROPERTIES.id,
              view: ALL_VIEW_IDS.TEAMS_PREFERENCES,
            }}
          >
            <Navigate
              to={`${ALL_APPS.ORG_SETTINGS.path}?tab=${ORG_PREFERENCES_TABS.TEAMS}`}
              replace
            />
          </PermissionsRouteWrapper>
        </MainCardWrapper>
      </>
    ),
  },
  {
    path: `${ALL_VIEWS.TAGS.path}`,
    element: (
      <>
        <ViewTabs appId={ALL_APP_IDS.PROPERTIES} />
        <FullHeightMainCardWrapper viewTabs>
          <PermissionsRouteWrapper
            permissionScope={{
              app: ALL_APPS.PROPERTIES.id,
              view: ALL_VIEW_IDS.TAGS,
            }}
          >
            <Tags />
          </PermissionsRouteWrapper>
        </FullHeightMainCardWrapper>
      </>
    ),
  },
  {
    path: `${ALL_VIEWS.CUSTOM_PROPERTIES.path}`,
    element: (
      <>
        <ViewTabs appId={ALL_APP_IDS.PROPERTIES} />
        <FullHeightMainCardWrapper viewTabs>
          <PermissionsRouteWrapper
            permissionScope={{
              app: ALL_APPS.PROPERTIES.id,
              view: ALL_VIEW_IDS.CUSTOM_PROPERTIES,
            }}
          >
            <Navigate
              to={`${ALL_APPS.ORG_SETTINGS.path}?tab=${ORG_PREFERENCES_TABS.CUSTOM_PROPERTIES}`}
              replace
            />
          </PermissionsRouteWrapper>
        </FullHeightMainCardWrapper>
      </>
    ),
  },
];
